import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from './Navigation';
import { API_ENDPOINTS } from '../config/api';
import './CatalogPage.css';

const CatalogPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedMuseum, setSelectedMuseum] = useState('all');
  const [reliefs, setReliefs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load all reliefs on component mount
  useEffect(() => {
    fetchReliefs();
  }, []);

  const fetchReliefs = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_ENDPOINTS.reliefs);
      setReliefs(response.data);
      console.log('Reliefs loaded:', response.data);
    } catch (error) {
      console.error('Error fetching reliefs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Implement search functionality
      console.log('Searching for:', searchQuery);
    } else {
      fetchReliefs();
    }
  };

  return (
    <div className="catalog-page">
      <Navigation />
      <div className="content">
        <h1>Bas-Relief Catalog</h1>
        
        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          
          <select 
            value={selectedMuseum}
            onChange={(e) => setSelectedMuseum(e.target.value)}
            className="museum-select"
          >
            <option value="all">All Museums</option>
            {/* Add museum options here */}
          </select>

          <button onClick={handleSearch} className="filter-button">
            Filter
          </button>
        </div>

        <div className="results-section">
          <p className="results-count">
            {loading ? 'Loading...' : `Found ${reliefs.length} reliefs`}
          </p>
          
          {loading ? (
            <div className="loading">Loading reliefs...</div>
          ) : reliefs.length > 0 ? (
            <div className="reliefs-grid">
              {reliefs.map((relief, index) => (
                <div key={relief.id || index} className="relief-card">
                  <h3>{relief.title || 'Untitled Relief'}</h3>
                  <p><strong>Location:</strong> {relief.location || 'Unknown'}</p>
                  <p><strong>Museum:</strong> {relief.museum || 'Unknown'}</p>
                  {relief.description && (
                    <p><strong>Description:</strong> {relief.description}</p>
                  )}
                  {relief.date && (
                    <p><strong>Date:</strong> {relief.date}</p>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="no-results">
              <p>No reliefs found. The database appears to be empty.</p>
              <p>Try adding some reliefs through the admin interface!</p>
            </div>
          )}
        </div>
      </div>
      
      <footer>
        <p>2024 Bas Relief Atlas - A Digital Archive of Neo-Assyrian Bas-Reliefs</p>
      </footer>
    </div>
  );
};

export default CatalogPage; 